import { SignalRAlarmType } from 'enums/signal-r-alarm-type'

/**
 * Label, ícone e classe de badge para um AlarmOutput.type (SignalRAlarmType,
 * 3 valores: ANPR/AHCR/SpeedViolation).
 *
 * Não confundir com AlarmConfigurationType (2 valores, sem SpeedViolation) —
 * usado por getConfigurationTypeLabel para as *configurações* de alarme, que
 * não têm o tipo "excesso de velocidade" por serem automáticas, não configuráveis.
 *
 * Antes desta função, a tela de histórico de alarmes decidia o rótulo com
 * `type === 1 ? 'Pessoas' : 'Veículos'` — SpeedViolation (2) caía no `else` e
 * aparecia rotulado como "Veículos" comum, sem indicar que era uma infração.
 */
export const ALARM_TYPE_LABELS: Record<SignalRAlarmType, string> = {
  [SignalRAlarmType.ANPR]: 'Veículos',
  [SignalRAlarmType.AHCR]: 'Pessoas',
  [SignalRAlarmType.SpeedViolation]: 'Excesso de Velocidade',
}

export const ALARM_TYPE_ICONS: Record<SignalRAlarmType, string> = {
  [SignalRAlarmType.ANPR]: 'pi-car',
  [SignalRAlarmType.AHCR]: 'pi-user',
  [SignalRAlarmType.SpeedViolation]: 'pi-gauge',
}

export const ALARM_TYPE_BADGE_CLASSES: Record<SignalRAlarmType, string> = {
  [SignalRAlarmType.ANPR]: 'alarms-type-color',
  [SignalRAlarmType.AHCR]: 'alarms-type-plate',
  [SignalRAlarmType.SpeedViolation]: 'alarms-type-speed',
}

export const getAlarmTypeLabel = (type: SignalRAlarmType): string =>
  ALARM_TYPE_LABELS[type] ?? 'Alarme'

export const getAlarmTypeIcon = (type: SignalRAlarmType): string =>
  ALARM_TYPE_ICONS[type] ?? 'pi-bell'

export const getAlarmTypeBadgeClass = (type: SignalRAlarmType): string =>
  ALARM_TYPE_BADGE_CLASSES[type] ?? 'alarms-type-color'
